import { render, staticRenderFns } from "./NewsLetters.vue?vue&type=template&id=ef1f0e50&scoped=true"
import script from "./NewsLetters.vue?vue&type=script&lang=js"
export * from "./NewsLetters.vue?vue&type=script&lang=js"
import style0 from "./NewsLetters.vue?vue&type=style&index=0&id=ef1f0e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1f0e50",
  null
  
)

export default component.exports